import React, { Component, Fragment } from 'react';
import { Redirect } from 'react-router-dom';
import {
  compose,
  withProps,
  branch,
  renderComponent,
  withHandlers,
} from 'recompose';
import TabNav from '../tabNav';
import { paymentMethods } from '../../util';
import { ActionButton } from '../buttons';
import {
  Wrapper,
  FormContainer,
  PaymentElementWrapper,
  PaymentElementHeading,
  CheckoutDividingHeading,
  CardIconWrapper,
  CardStyle,
} from './style';
import Tip from '../tip';
import {
  StripeProvider,
  CardCVCElement,
  CardExpiryElement,
  CardNumberElement,
  IbanElement,
  injectStripe,
  Elements,
} from 'react-stripe-elements';
import DeliverySummary from '../deliverysummary';
import { FlexRow, FlexCol, Text } from '../misc';
import MasterCardIcon from '../../images/masterCardIcon';
import VisaCardIcon from '../../images/visaCardIcon';

class PaymentElement extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hasFocus: false,
    };

    this.onFocus = this.onFocus.bind(this);
    this.onBlur = this.onBlur.bind(this);
  }

  onFocus() {
    this.setState({ hasFocus: true });
  }
  onBlur() {
    this.setState({ hasFocus: false });
  }

  render() {
    const { hasFocus } = this.state;
    const { fullWidth, heading } = this.props;
    return (
      <FlexCol
        css={`
          width: 100%;
        `}
      >
        <PaymentElementHeading hasFocus={hasFocus}>
          {heading}
        </PaymentElementHeading>
        <PaymentElementWrapper fullWidth={fullWidth} hasFocus={hasFocus}>
          {this.props.children({
            onFocus: this.onFocus,
            onBlur: this.onBlur,
          })}
        </PaymentElementWrapper>
      </FlexCol>
    );
  }
}

const PaymentButton = ({
  createOrder,
  type,
  stripe,
  methodProps,
  disabled,
}) => (
  <ActionButton
    disabled={disabled}
    style={{
      marginTop: '16px',
    }}
    onClick={() =>
      createOrder({
        stripe,
        payment: { type: type, ...methodProps },
      })
    }
  >
    Mit {methodProps.name} bezhalen
  </ActionButton>
);

const Giropay = ({ createOrder, stripe, methodProps }) => (
  <FlexCol
    css={`
      margin: 16px 0;
    `}
  >
    <Tip
      text={`Wenn Sie sich für Giropay als Bezahlmethode entscheiden, werden Sie auf die sichere Seite Ihrer Bank weitergeleitet.
      Hinweis: Verwenden Sie bei der Bankensuche die BIC.`}
      iconSize={30}
    />
    <PaymentButton
      createOrder={createOrder}
      type="giropay"
      stripe={stripe}
      methodProps={methodProps}
    />
  </FlexCol>
);

class Card extends Component {
  state = {
    cardNumberComplete: false,
    cardExpiryComplete: false,
    cardCVCComplete: false,
  };

  onComplete = type => {
    if (type === 'number') this.setState({ cardNumberComplete: true });
    if (type === 'expiry') this.setState({ cardExpiryComplete: true });
    if (type === 'cvc') this.setState({ cardCVCComplete: true });
  };

  onError = type => {
    if (type === 'number') this.setState({ cardNumberComplete: false });
    if (type === 'expiry') this.setState({ cardExpiryComplete: false });
    if (type === 'cvc') this.setState({ cardCVCComplete: false });
  };

  render() {
    const { createOrder, stripe, methodProps } = this.props;
    const {
      cardNumberComplete,
      cardExpiryComplete,
      cardCVCComplete,
    } = this.state;
    const cardComplete =
      cardNumberComplete && cardExpiryComplete && cardCVCComplete;
    return (
      <FlexCol
        css={`
          margin: 16px 0;
        `}
      >
        <CardIconWrapper>
          <MasterCardIcon />
          <VisaCardIcon />
        </CardIconWrapper>
        <PaymentElement fullWidth heading="Kartennummer">
          {({ onFocus, onBlur }) => (
            <CardNumberElement
              onChange={props => {
                const type = 'number';
                if (props.error) this.onError(type);
                if (props.complete) this.onComplete(type);
              }}
              onFocus={onFocus}
              onBlur={onBlur}
              style={CardStyle}
            />
          )}
        </PaymentElement>
        <FlexRow
          css={`
            margin-top: 8px;
          `}
        >
          <PaymentElement heading="Gültig bis">
            {({ onFocus, onBlur }) => (
              <CardExpiryElement
                onChange={props => {
                  const type = 'expiry';
                  if (props.error) this.onError(type);
                  if (props.complete) this.onComplete(type);
                }}
                onFocus={onFocus}
                onBlur={onBlur}
                style={CardStyle}
              />
            )}
          </PaymentElement>
          <PaymentElement heading="CVC Code">
            {({ onFocus, onBlur }) => (
              <CardCVCElement
                onChange={props => {
                  const type = 'cvc';
                  if (props.error) this.onError(type);
                  if (props.complete) this.onComplete(type);
                }}
                onFocus={onFocus}
                onBlur={onBlur}
                style={CardStyle}
              />
            )}
          </PaymentElement>
        </FlexRow>
        <PaymentButton
          disabled={!cardComplete}
          type="card"
          createOrder={createOrder}
          stripe={stripe}
          methodProps={methodProps}
        />
      </FlexCol>
    );
  }
}

class Sepa extends Component {
  state = { ibanComplete: false };

  onComplete = () => {
    this.setState({ ibanComplete: true });
  };

  onError = () => {
    this.setState({ ibanComplete: false });
  };

  render() {
    const { createOrder, stripe, methodProps } = this.props;
    const { ibanComplete } = this.state;
    return (
      <FlexCol
        css={`
          margin: 16px 0;
        `}
      >
        <PaymentElement fullWidth heading="IBAN">
          {({ onFocus, onBlur }) => (
            <IbanElement
              supportedCountries={['SEPA']}
              onChange={props => {
                if (props.error) this.onError();
                if (props.complete) this.onComplete();
              }}
              style={CardStyle}
              onFocus={onFocus}
              onBlur={onBlur}
            />
          )}
        </PaymentElement>
        <Text
          css={`
            padding-top: 8px;
            padding-left: 8px;
            padding-right: 8px;
            font-size: 14px;
          `}
        >
          Indem Sie Ihre IBAN zur Verfügung stellen und diese Zahlung
          bestätigen, ermächtigen Sie die Opticunion GmbH Zahlungen von Ihrem
          Konto mittels Lastschrift einzuziehen. Sie können innerhalb 8 Wochen,
          beginnend mit dem Belastungsdatum, die Erstattung des belasteten
          Betrages verlangen. Es gelten dabei die vereinbarten Bedingungen mit
          Ihrem Kreditinstitut.
        </Text>
        <PaymentButton
          disabled={!ibanComplete}
          type="sepa_debit"
          createOrder={createOrder}
          stripe={stripe}
          methodProps={methodProps}
        />
      </FlexCol>
    );
  }
}

class Stripe extends Component {
  state = { cardCompleted: false };

  render() {
    const { methods, createOrder, stripe } = this.props;

    return (
      <TabNav>
        <TabNav.NavList>
          {methods.map(method => (
            <TabNav.NavListItem key={method}>
              {paymentMethods[method].name}
            </TabNav.NavListItem>
          ))}
        </TabNav.NavList>
        <TabNav.NavListPanels>
          {methods.map(method => {
            const methodProps = paymentMethods[method];
            return (
              <Fragment key={method}>
                {method === 'card' && (
                  <Card
                    methodProps={methodProps}
                    stripe={stripe}
                    createOrder={createOrder}
                  />
                )}
                {method === 'giropay' && (
                  <Giropay
                    methodProps={methodProps}
                    stripe={stripe}
                    createOrder={createOrder}
                  />
                )}
                {method === 'sepa_debit' && (
                  <Sepa
                    methodProps={methodProps}
                    stripe={stripe}
                    createOrder={createOrder}
                  />
                )}
              </Fragment>
            );
          })}
        </TabNav.NavListPanels>
      </TabNav>
    );
  }
}

const InjectedStripe = injectStripe(Stripe);

const Debit = ({ createOrder }) => (
  <Fragment>
    <div
      css={`
        padding: 0 15px 15px 15px;
        margin-bottom: 10px;
      `}
    >
      <Tip
        text="Die Lieferung erfolgt zu den vereinbarten Zahlungskonditionen."
        iconSize={40}
      />
    </div>
    <ActionButton
      onClick={() =>
        createOrder({
          payment: { type: 'Lastschrift' },
        })
      }
    >
      Verbindlich bestellen
    </ActionButton>
  </Fragment>
);

class PaymentForm extends Component {
  static Stripe = props =>
    props.isStripePayment ? (
      <Elements>
        <InjectedStripe {...props} />
      </Elements>
    ) : null;
  static Debit = props => (props.isStripePayment ? null : <Debit {...props} />);
  static Error = props =>
    props.payOrderStatus === 'error' || props.createSourceStatus === 'error' ? (
      <FlexCol
        css={`
          margin: 16px 0;
          border-top: 0.7px solid rgba(218, 225, 231, 1);
        `}
      >
        <Tip
          text={
            props.payOrderError ? props.payOrderError : props.createSourceError
          }
          iconSize={30}
        />
      </FlexCol>
    ) : null;
  render() {
    return (
      <Wrapper>
        <FormContainer>
          <CheckoutDividingHeading>Lieferung</CheckoutDividingHeading>
          <DeliverySummary {...this.props} />
          <CheckoutDividingHeading>Bestellung</CheckoutDividingHeading>
          {this.props.children}
        </FormContainer>
      </Wrapper>
    );
  }
}

class Payment extends Component {
  render() {
    return (
      <StripeProvider apiKey={process.env.REACT_APP_STRIPE_API_KEY}>
        <PaymentForm {...this.props}>
          <PaymentForm.Stripe {...this.props} />
          <PaymentForm.Debit {...this.props} />
          <PaymentForm.Error {...this.props} />
        </PaymentForm>
      </StripeProvider>
    );
  }
}

const getRelevantPaymentMethods = country => {
  return Object.keys(paymentMethods).filter(paymentMethodName => {
    const paymentMethod = paymentMethods[paymentMethodName];
    if (!paymentMethod.countries) {
      return true;
    }

    if (
      paymentMethod.countries &&
      paymentMethod.countries.indexOf(country) != -1
    ) {
      return true;
    }
  });
};

const redirectIfNoData = hasNoData =>
  branch(hasNoData, renderComponent(() => <Redirect to="/" />));

const enhance = compose(
  redirectIfNoData(
    props => !(props.profile && props.deliveryAddress && props.invoiceAddress)
  ),
  withProps(ownProps => {
    const { profile } = ownProps;

    const isStripePayment = profile.customer_payment_constraint === 'prepay';
    const paymentMethods = getRelevantPaymentMethods(profile.customer_country);
    return {
      methods: paymentMethods,
      isStripePayment,
    };
  }),
  withHandlers(initialProps => {
    const { history } = initialProps;
    return {
      createOrder: props => ({ stripe, payment }) => {
        return props.createOrder({
          stripe,
          payment,
          history,
        });
      },
    };
  })
);

export default enhance(Payment);



// WEBPACK FOOTER //
// ./src/components/payment/index.js